import { DELETEINVOICE_SUCCESS, DELETEINVOICE_FAIL } from "../actionTypes";

const initialState = {
    user: null,
};

const deleteInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEINVOICE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEINVOICE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deleteInvoiceReducer;
